import type { Connectivity, DeviceStatus, IncidentStatus, Severity, RangeState } from "@/contracts";
import {
  IconAlertCircle,
  IconAlertOctagon,
  IconAlertTriangle,
  IconCircleCheck,
  IconClock,
  IconInfoCircle,
  IconPlayerStop,
  IconQuestionMark,
  IconTool,
  IconUserCheck,
  IconWifi,
  IconWifiOff,
} from "@tabler/icons-react";

import { Badge } from "@/components/ui/badge";
import {
  CONNECTIVITY,
  DEVICE_STATUS,
  INCIDENT_STATUS,
  SEVERITY,
  RANGE_STATE,
} from "./device-labels";

export function ConnectivityBadge({ value }: { value: Connectivity }) {
  const { label, tone } = CONNECTIVITY[value];
  const icon =
    value === "ONLINE" ? IconWifi : value === "OFFLINE" ? IconWifiOff : IconQuestionMark;

  return (
    <Badge tone={tone} icon={icon}>
      {label}
    </Badge>
  );
}

export function RangeStateBadge({ value }: { value: RangeState }) {
  const { label, tone } = RANGE_STATE[value];
  const icon =
    value === "IN_RANGE"
      ? IconCircleCheck
      : value === "OUT_OF_RANGE"
        ? IconAlertTriangle
        : IconQuestionMark;

  return (
    <Badge tone={tone} icon={icon}>
      {label}
    </Badge>
  );
}

export function DeviceStatusBadge({ value }: { value: DeviceStatus }) {
  const { label, tone } = DEVICE_STATUS[value];
  const icon =
    value === "PENDING"
      ? IconClock
      : value === "ACTIVE"
        ? IconCircleCheck
        : value === "INACTIVE"
          ? IconPlayerStop
          : IconTool;

  return (
    <Badge tone={tone} icon={icon}>
      {label}
    </Badge>
  );
}

export function SeverityBadge({ value }: { value: Severity }) {
  const { label, tone } = SEVERITY[value];
  const icon =
    value === "INFO"
      ? IconInfoCircle
      : value === "WARNING"
        ? IconAlertTriangle
        : IconAlertOctagon;

  return (
    <Badge tone={tone} icon={icon}>
      {label}
    </Badge>
  );
}

export function IncidentStatusBadge({ value }: { value: IncidentStatus }) {
  const { label, tone } = INCIDENT_STATUS[value];
  const icon =
    value === "OPEN"
      ? IconAlertCircle
      : value === "ACKNOWLEDGED"
        ? IconUserCheck
        : IconCircleCheck;

  return (
    <Badge tone={tone} icon={icon}>
      {label}
    </Badge>
  );
}
